import React from 'react';
import Label from '@material-ui/icons/Label'
import MailIcon from '@material-ui/icons/Mail';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'; 
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExitToAppRounded from '@material-ui/icons/ExitToAppRounded';
import Info from '@material-ui/icons/Info';
import SettingsIcon from '@material-ui/icons/Settings';
import SearchIcon from '@material-ui/icons/Search';
import Face from '@material-ui/icons/Face';
import Folder from '@material-ui/icons/Folder'
import Assign from '@material-ui/icons/Assignment'
import Archive from '@material-ui/icons/Archive'
import Money from '@material-ui/icons/MonetizationOn';
import Create from '@material-ui/icons/Create';
import People from '@material-ui/icons/People';
import Time from '@material-ui/icons/AccessTime';
import Drive from '@material-ui/icons/InsertDriveFile';
import List from '@material-ui/icons/List';
import Book from '@material-ui/icons/Book';
import Avatar from '@material-ui/core/Avatar';
import CloseIcon from '@material-ui/icons/Close';
import ViewListRoundedIcon from '@material-ui/icons/ViewListRounded';
import Notification from '@material-ui/icons/NotificationImportant';
import Visibility from '@material-ui/icons/Visibility';
import Visibilityoff from '@material-ui/icons/VisibilityOff';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import PrintIcon from '@material-ui/icons/Print';
import PrintDisabledIcon from '@material-ui/icons/PrintDisabled';
import BackspaceIcon from '@material-ui/icons/Backspace';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import NavigationIcon from '@material-ui/icons/Navigation';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CheckIcon from '@material-ui/icons/Check';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FilterListIcon from '@material-ui/icons/FilterList';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import Copy from '@material-ui/icons/FileCopy';
import PageviewIcon from '@material-ui/icons/Pageview';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import PaletteIcon from '@material-ui/icons/Palette';
import FormatColorTextIcon from '@material-ui/icons/FormatColorText';
import PaymentIcon from '@material-ui/icons/Payment';
import HelpIcon from '@material-ui/icons/Help';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import RefreshIcon from '@material-ui/icons/Refresh';
import BackspaceTwoToneIcon from '@material-ui/icons/BackspaceTwoTone';
import DeleteSweepTwoToneIcon from '@material-ui/icons/DeleteSweepTwoTone';
import PieChartIcon from '@material-ui/icons/PieChart';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import TimelineIcon from '@material-ui/icons/Timeline';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import ExtensionRoundedIcon from '@material-ui/icons/ExtensionRounded';
import FingerprintRoundedIcon from '@material-ui/icons/FingerprintRounded';
import StarBorderRoundedIcon from '@material-ui/icons/StarBorderRounded';
import TransferWithinAStationRoundedIcon from '@material-ui/icons/TransferWithinAStationRounded';
import PermScanWifiRoundedIcon from '@material-ui/icons/PermScanWifiRounded';

//Adicion solicitado por Elio
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SyncIcon from '@material-ui/icons/Sync';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import EmailIcon from '@material-ui/icons/Email';
import PlaceIcon from '@material-ui/icons/Place';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PersonIcon from '@material-ui/icons/Person';

//Adicion solicitada por Martin tú también
import HouseIcon from '@material-ui/icons/House';
import School from '@material-ui/icons/School';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import Lock from '@material-ui/icons/Lock';
import LockOpen from '@material-ui/icons/LockOpen';

//Adicion hecha por Jared
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import ReplayIcon from '@material-ui/icons/Replay';
import FormatListNumberedOutlinedIcon from '@material-ui/icons/FormatListNumberedOutlined';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import PostAddIcon from '@material-ui/icons/PostAdd';
import DescriptionIcon from '@material-ui/icons/Description';

function Icono(props){
    
    const {icono,...others} = props;

    var icon={
        Label:                  <Label {...others}/>,
        MailIcon:               <MailIcon {...others}/>,
        ExpandMoreIcon:         <ExpandMoreIcon  {...others}/>,
        MenuIcon:               <MenuIcon {...others}/>,
        ChevronLeftIcon:    <ChevronLeftIcon {...others}/>,
        ChevronRightIcon:   <ChevronRightIcon  {...others}/>,
        ExitToAppRounded:   <ExitToAppRounded {...others}/>,
        Info:               <Info  {...others}/>,
        SettingsIcon:       <SettingsIcon {...others}/>,
        Face:               <Face {...others}/>,
        Folder:             <Folder {...others}/>,
        Assign:             <Assign {...others}/>,
        Archive:            <Archive {...others}/>,
        Money:              <Money {...others}/>,
        Create:             <Create {...others}/>,
        People:             <People {...others}/>,
        Time:               <Time {...others}/>,
        Drive:              <Drive {...others}/>,
        List:               <List {...others}/>,
        Book:               <Book {...others}/>,
        Close:              <CloseIcon {...others}/>,
	Check:              <CheckIcon {...others}/>,
        ViewList:           <ViewListRoundedIcon {...others}/>,
        Notification:       <Notification {...others}/>,
        Visibility:         <Visibility   {...others}/>, 
	Visibilityoff:      <Visibilityoff   {...others}/>,
        Delete:             <DeleteForeverIcon   {...others}/>,
        Add:                <AddCircleIcon   {...others}/>,
        Edit:               <EditIcon   {...others}/>,
        Save:               <SaveIcon {...others}/>,
        Like:               <ThumbUpAltIcon {...others}/>,
        NotLike:            <ThumbDownAltIcon {...others}/>,
        Print:              <PrintIcon {...others}/>,
        PrintDisabled:      <PrintDisabledIcon {...others}/>,
        Search:             <SearchIcon {...others}/>,
        Backspace:              <BackspaceIcon {...others}/>,
        ArrowDropDown:          <ArrowDropDownIcon {...others}/>,
        ArrowRight:             <ArrowRightIcon {...others}/>,
        ArrowUp:             <NavigationIcon {...others}/>,
        ArrowDown:             <KeyboardArrowDownIcon {...others}/>,
        ArrowLeft:             <ArrowBackIosIcon {...others}/>,
        ArrowRightBounce:             <ArrowForwardIosIcon {...others}/>,
	MoreVertIcon:           <MoreVertIcon {...others}/>,
        Filter:                 <FilterListIcon {...others}/>,
        copy:                   <Copy {...others}/>,
        Pageview:               <PageviewIcon {...others}/>,
        ExpandLessIcon:         <ExpandLessIcon {...others}/>,
        CheckCircle:            <CheckCircleIcon {...others}/>,
        CancelIcon:             <CancelIcon {...others}/>,
        TimeFill:               <WatchLaterIcon {...others}/>,
        PaletteIcon:            <PaletteIcon  {...others}/>,
        FormatColorTextIcon:    <FormatColorTextIcon  {...others}/>,
        PaymentIcon:            <PaymentIcon {...others}/>,
        HelpIcon:               <HelpIcon {...others}/>,
        QueuePlayNextIcon:      <QueuePlayNextIcon {...others}/>,
	RefreshIcon:            <RefreshIcon {...others}/>,
        BackspaceTwoToneIcon:   <BackspaceTwoToneIcon {...others}/>,
        DeleteSweepTwoToneIcon: <DeleteSweepTwoToneIcon {...others}/>,
        PieChartIcon:           <PieChartIcon {...others}/>,
        BubbleChartIcon:        <BubbleChartIcon {...others}/>,
        TimelineIcon:           <TimelineIcon {...others}/>,
        EqualizerIcon:          <EqualizerIcon {...others}/>,
        AssessmentIcon:         <AssessmentIcon {...others}/>,
        ContactPhoneIcon:       <ContactPhoneIcon {...others}/>,
        EmojiPeopleIcon:        <EmojiPeopleIcon {...others}/>,
        ExtensionRoundedIcon:   <ExtensionRoundedIcon {...others}/>,
        FingerprintRoundedIcon: <FingerprintRoundedIcon {...others}/>,
        StarBorderRoundedIcon:  <StarBorderRoundedIcon {...others}/>,
        TransferWithinAStationRoundedIcon:      <TransferWithinAStationRoundedIcon {...others}/>,
        PermScanWifi: <PermScanWifiRoundedIcon {...others}/>,

        //Adicion solicitado por Elio
        Copy:                   <FileCopyIcon {...others}/>,
        Sync:                   <SyncIcon {...others}/>,
        AttachMoney:            <AttachMoneyIcon {...others}/>,
        Email:                  <EmailIcon {...others}/>,
	Place:                  <PlaceIcon {...others}/>,
        ListAlt:                <ListAltIcon {...others}/>,
        SwapHoriz:              <SwapHorizIcon {...others}/>,
	Person:                 <PersonIcon {...others}/>,

        //Adicion solicitada por Martin tú también
        House:                  <HouseIcon {...others}/>,
        School:                 <School {...others}/>,
        LocalLibrary:           <LocalLibraryIcon {...others}/>,
        HomeWork:               <HomeWorkIcon  {...others}/>,
        AssignmentInd:          <AssignmentInd  {...others}/>,
        Lock: <Lock {...others}/>,
        LockOpen: <LockOpen {...others} />,

        //Adicion hecha por Jared
	GroupAdd:               <GroupAddIcon {...others}/>,
	SttingScuare:           <SettingsApplicationsIcon {...others}/>,
	Reload:                 <ReplayIcon {...others}/>,
	ListNumberOutlined:     <FormatListNumberedOutlinedIcon {...others}/>,
        AssignmentIcon:         <AssignmentIndIcon {...others}/>,
        ClearAll:               <ClearAllIcon {...others}/>,
        PostAdd:                <PostAddIcon {...others}/>,
        Description:            <DescriptionIcon {...others}/>,
    }

    if(icon[icono]!==undefined)
        return(icon[icono]);
    else
        return(<Avatar style={{width:20,height:20,marginRight: 5}}/>);

};
export default function ObtenerIcono(props) {
    return (
            <Icono {...props}/>
    );
}
